import { ghostBtnClass, inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { promoteObservationToChecklist } from "@/lib/manufacturing/builderAssistantChecklistClient";
import type { BuilderAssistantObservation } from "@/lib/manufacturing/builderAssistantTypes";

export function BuilderAssistantLooseFindings({
  examples,
  loose,
  categories,
  categoryByObservation,
  disabled,
  onCategory,
  onAdded,
  onError,
}: {
  examples: BuilderAssistantObservation[];
  loose: BuilderAssistantObservation[];
  categories: { id: string; name: string }[];
  categoryByObservation: Record<string, string>;
  disabled: boolean;
  onCategory: (observationId: string, categoryId: string) => void;
  onAdded: () => Promise<void> | void;
  onError: (message: string) => void;
}) {
  if (examples.length === 0 && loose.length === 0) return null;
  return (
    <>
      {examples.length > 0 ? (
        <div className="space-y-1">
          <h4 className="text-sm font-semibold text-gray-800 dark:text-zinc-200">Build book examples</h4>
          <ul className="text-xs text-gray-600 dark:text-zinc-400">
            {examples.map((row) => (
              <li key={row.id}>{row.description.slice(0, 140)}</li>
            ))}
          </ul>
        </div>
      ) : null}
      {loose.length > 0 ? (
        <div className="space-y-2">
          <h4 className="text-sm font-semibold text-gray-800 dark:text-zinc-200">Not on the checklist</h4>
          <ul className="space-y-2">
            {loose.map((row) => (
              <li key={row.id} className="flex flex-wrap items-center gap-2 text-sm">
                <span className="text-gray-800 dark:text-zinc-200">{row.description.slice(0, 120)}</span>
                <select
                  className={inputClass}
                  value={categoryByObservation[row.id] ?? ""}
                  onChange={(event) => onCategory(row.id, event.target.value)}
                >
                  <option value="">General</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>{category.name}</option>
                  ))}
                </select>
                <button
                  type="button"
                  className={ghostBtnClass}
                  disabled={disabled}
                  onClick={() => {
                    void promoteObservationToChecklist(row.id, categoryByObservation[row.id] ?? "").then(async (res) => {
                      if (!res.ok) {
                        onError(res.error);
                        return;
                      }
                      await onAdded();
                    });
                  }}
                >
                  Add to checklist
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
}
